import React from "react";
import PropTypes from "prop-types";
import { Link, withRouter } from "react-router-dom";
import cn from "classnames";
import logo from "../logo.svg";

const AppBar = ({ auth, location }) => {
  const { isAuthenticated, login, logout } = auth;
  const { pathname } = location;
  const linkStyle =
    "ml-2 px-2 sm:px-3 py-2 rounded-md leading-5 text-sm hover:no-underline font-medium text-blue-100 hover:text-white hover:bg-blue-400 focus:outline-none focus:text-white focus:bg-blue-400 transition duration-150 ease-in-out";

  return (
    <nav className="relative z-10 bg-blue-500 mb-8 shadow-sm">
      <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-8">
        <div className="relative flex items-center justify-between h-16">
          <div className="flex items-center px-2 lg:px-0">
            <div className="flex-shrink-0">
              <img
                src={logo}
                className="block h-8 w-auto"
                alt="Global Bible Logo"
              />
            </div>
            <div className="ml-2 lg:ml-6">
              <div className="flex">
                <Link
                  to="/sites"
                  className={cn(linkStyle, {
                    "bg-blue-700": pathname.startsWith("/sites")
                  })}
                >
                  Sites
                </Link>
                <Link
                  to="/bibles"
                  className={cn(linkStyle, {
                    "bg-blue-700": pathname.startsWith("/bibles")
                  })}
                >
                  Bibles
                </Link>
              </div>
            </div>
          </div>
          <div>
            <button
              type="button"
              onClick={() => (isAuthenticated() ? logout() : login())}
              className={cn(linkStyle, "border border-blue-100")}
            >
              {isAuthenticated() ? "Log out" : "Log in"}
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

AppBar.propTypes = {
  auth: PropTypes.shape({
    login: PropTypes.func,
    logout: PropTypes.func,
    isAuthenticated: PropTypes.func
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string
  }).isRequired
};

export default withRouter(AppBar);
